import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";

import { KycRealTimeChange } from "./kyc-actions.model";

const ACTION_PREFIX = "[KYC actions]";

export const KYC_ACTIONS_ACTION_TYPE = {
	kycStatusChange: `${ACTION_PREFIX} KYC Status Change`,
	customerActionsChange: `${ACTION_PREFIX} Customer Actions`,
};

@Injectable({
	providedIn: "root",
})
export class KycActionsAction {
	kycStatusChange(payload: KycRealTimeChange): ActionWithPayload {
		return {
			type: KYC_ACTIONS_ACTION_TYPE.kycStatusChange,
			payload,
		};
	}

	/**
	 * @param payload not needed atm
	 * @returns
	 */
	customerActionsChange(): Action {
		return {
			type: KYC_ACTIONS_ACTION_TYPE.customerActionsChange,
		};
	}
}
